<template>
  <v-row no-gutters>
    <v-col cols="12" sm="6">
      <span class="d-block mt-4 mb-4 body-2 text--secondary font-weight-medium">{{ account.name }}</span>
      <span class="d-block mb-2 body-1 text--secondary font-weight-medium">{{ data.description }}</span>

      <span v-if="data.amount_scheme === 'fixed'" class="d-block text-h4 text--secondary font-weight-medium">{{ data.amount | currency(data.currency) }} {{ data.currency }}</span>
      <span v-if="data.amount_scheme === 'custom' && data.amount_preset" class="d-block text-h4 text--secondary font-weight-medium">{{ (data.amount_preset || data.amount) | currency(data.currency) }} {{ data.currency }}</span>

      <template v-if="data.amount_scheme === 'custom' && !data.amount_preset">
        <v-text-field class="d-inline-block mx-0 v-input--lg" autocomplete="off" background-color="white" dense hide-details maxlength="8" outlined persistent-hint readonly single-line style="max-width:180px;">
          <template slot="prepend-inner">
            <span class="ml-2 text--secondary font-weight-medium" style="margin-top:3px;">{{ data.currency }}</span>
          </template>
        </v-text-field>

        <span class="d-block caption">
          <template v-if="data.amount_min && data.amount_max">Ingresa un monto entre {{ data.amount_min | currency(data.currency) }} y {{ data.amount_max | currency(data.currency)}} {{ data.currency }}</template>
          <template v-else-if="data.amount_min">Ingresa un monto mínimo de {{ data.amount_min | currency(data.currency) }} {{ data.currency }}</template>
          <template v-else-if="data.amount_max">Ingresa un monto máximo de {{ data.amount_max | currency(data.currency) }} {{ data.currency }}</template>
        </span>
      </template>

      <v-btn v-if="data.amount_scheme === 'custom' && data.amount_preset" class="d-block mt-3" :color="account.color_background" :ripple="false" text>Cambiar el monto</v-btn>
    </v-col>
    <v-col cols="12" sm="6">
      <v-sheet class="my-3 mx-auto overflow-hidden" rounded outlined>
        <v-card-text>
          <v-row>
            <v-col class="py-1" cols="12">
              <span class="d-block ml-1 text--secondary font-weight-medium">
                <template v-if="data.customer_type === 'individual'">Información de pago</template>
                <template v-else>Información de facturación</template>
              </span>
            </v-col>
            <v-col class="py-1" cols="12">
              <v-text-field :color="account.color_background" dense hide-details :label="fieldLabels.name" maxlength="64" outlined persistent-hint readonly />
            </v-col>
            <v-col class="py-1" cols="12">
              <v-text-field :color="account.color_background" dense hide-details label="Dirección" maxlength="64" outlined persistent-hint readonly />
            </v-col>
            <v-col class="py-1" cols="6">
              <v-autocomplete :color="account.color_background" dense hide-details item-value="id" item-text="name" label="País" outlined persistent-hint readonly />
            </v-col>
            <v-col class="py-1" cols="6">
              <v-autocomplete :color="account.color_background" dense hide-details item-value="id" item-text="name" :label="fieldLabels.state" outlined persistent-hint readonly />
            </v-col>
            <v-col class="py-1" cols="12" v-if="data.customer_type === 'both'">
              <v-radio-group row>
                <v-radio class="mr-8" label="Empresa" value="business" />
                <v-radio class="mr-8" label="Persona" value="person" />
              </v-radio-group>
            </v-col>
            <v-col class="py-1" cols="6">
              <v-text-field :color="account.color_background" dense hide-details :label="fieldLabels.taxId" maxlength="32" outlined persistent-hint readonly />
            </v-col>
            <v-col class="py-1" cols="6">
              <v-text-field :color="account.color_background" dense hide-details label="Código postal" maxlength="32" outlined persistent-hint readonly />
            </v-col>
            <v-col class="py-1" cols="12">
              <v-text-field :color="account.color_background" dense hide-details label="Email" maxlength="32" outlined persistent-hint readonly />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-text class="px-0 background">
          <v-row class="px-4" no-gutters>
            <v-col cols="12">
              <span class="d-block ml-1 text--secondary font-weight-medium">Elige cómo quieres pagar</span>
            </v-col>
            <v-col cols="12" class="px-0">
              <v-radio-group class="mt-3 mb-4" hide-details>
                <v-list class="pa-0" outlined rounded>
                  <template v-for="(p, i) in providers">
                    <v-list-item class="my-0" :key="p">
                      <v-list-item-content class="py-0 overflow-visible">
                        <v-radio class="py-3" :color="account.color_background" :value="p">
                          <template v-slot:label>
                            <v-row class="pl-3" align="center" justify="space-between">
                              <img class="ml-4" :alt="p" height="28" :src="require(`@/assets/appAsset-brand--${p}.svg`)" />
                            </v-row>
                          </template>
                        </v-radio>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider v-if="i < providers.length - 1" :key="`${p}-divider`" />
                  </template>
                </v-list>
              </v-radio-group>
            </v-col>
            <v-col cols="12" class="px-0">
              <v-btn :color="account.color_background" dark height="40" block>Siguiente</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-sheet>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import gateways from '@/collections/gateways'

import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({
        amount: null,
        amount_min: null,
        amount_max: null,
        amount_preset: null,
        amount_scheme: 'fixed',
        cta: 'pay',
        currency: null,
        description: '',
        end_description: '',
        image: '',
        name: 'Nuevo link de pago',
        redirect_url: ''
      })
    },
    step: {
      type: Number,
      required: true
    }
  },
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    fieldLabels: {
      name: 'Nombre o empresa',
      state: 'Estado',
      taxId: 'ID Fiscal'
    },
    gateways: gateways,
    method: 0,
    selectedGateway: null,
    toggleSource: false
  }),
  computed: {
    ...mapState({
      providersList: state => state.payments.providersList
    }),
    /**
     * Returns an array of gateway providers based on the currencies, providers list & single use.
     *
     * @returns {Array} An array of gateway providers.
     */
    providers () {
      const providers = this.providersList.map(p => p.gateway)
      return gateways.filter(p => p.currencies.includes(this.data.currency) && providers.includes(p.id) && p.allow_single_use).map(p => p.id)
    }
  },
  watch: {
    'data.customer_type' (newValue) {
      if (newValue === 'individual') {
        this.fieldLabels.name = 'Nombre'
      } else if (newValue === 'business') {
        this.fieldLabels.name = 'Empresa'
      } else {
        this.fieldLabels.name = 'Nombre o Empresa'
      }
    },
    providers () {
      if (this.providers.length) {
        this.selectedGateway = this.providers[0]
      }
    }
  },
  created () {
    this.$store.dispatch('payments/LIST', {
      resource: 'providers',
      query: {
        gateway__currencies__in: [this.currency]
      }
    })
  }
}
</script>